
function Animate({ animate, children, ...rest }) {
    return (
        <div data-aos={animate} {...rest}  data-aos-anchor-placement="bottom-bottom">{children}</div>
    )
}

export default Animate